import { ReactNode } from 'react'
import SignInHeader from '../../components/admin/SignInHeader'
import Greeting from '../../components/common/Greeting'
import SignInLayout from '../../components/layout/SignInLayout'
import ActivitySummaryBox from '../../components/user/ActivitySummaryBox'
import ActivitySummaryBoxMobile from '../../components/user/ActivitySummaryBoxMobile'
import styles from '../../styles/admin/SignIn.module.scss'
import ActivitySummaryLayout from '../../components/layout/ActivitySummaryLayout'

type LayoutType = 'none' | 'standard' | 'secondary' | 'tertiary'

interface SignInPageProps {
  content?: ReactNode
  layout?: LayoutType
  hasGreeting?: boolean
}

const Summary: React.FC<SignInPageProps> = ({
  content,
  layout = 'none',
  hasGreeting = false,
}) => {
  return (
    <ActivitySummaryLayout>
      <SignInHeader />
      <div className={styles.signInContentWrapper}>
        <div className={styles.textWrapper}>
          {hasGreeting && <Greeting className={styles.greetingWrapper} />}
        </div>

        <div className={styles.desktopOnly}>
          <ActivitySummaryBox />
        </div>

        <div className={styles.mobileOnly}>
          <ActivitySummaryBoxMobile />
        </div>
      </div>
    </ActivitySummaryLayout>
  )
}

export default Summary
function useMediaQuery(arg0: string) {
  throw new Error('Function not implemented.')
}
